import React from 'react';

import Row from "react-bootstrap/Row";


const Temp= (   ) => {


    return (
        <>

            <Row className="mb-3 text-start">
                <h4 className="text-center">
        {/*Registration opens Tuesday, September 9th.<br/>*/}
{/*Please visit again after that time.<br/>*/}
{/*We look forward to working with you!*/}
                    To apply for the 2026-27 program, <a href="https://portal.sarasch.com/dual-application/" target="_blank">click here.</a><br/>
Please note: course registration for 2026-27 is not yet open.<br/>
If you have any questions, reach out to Mrs. Lieba Berger at <a href="mailto:lberger@sarasch.com" target="_blank">lberger@sarasch.com</a>.
        </h4>
            </Row>
            </>
            );
}



            export default Temp;
